// Imports
import { MarkdownGfmDataProcessor } from '@ckeditor/ckeditor5-markdown-gfm';
import { Plugin, Editor } from '@ckeditor/ckeditor5-core';


// Plugin
export default class Markdown extends Plugin {
	// Reassign editor data processor on instantiation
	constructor(editor: Editor) {
		super(editor);
		editor.data.processor = new MarkdownGfmDataProcessor(this.editor.editing.view.document);
	}
	
	
	// The name this plugin can be referred to by
	public static get pluginName(): 'Markdown' {
		return 'Markdown';
	}
}
